import type { StripeAddressValue } from '../components/StripeCheckout';
import type { AddressInput } from '../types/gql-op-types';

export function toAddressInput(address: StripeAddressValue): AddressInput {
  return {
    line1: address.address.line1,
    line2: address.address.line2 ?? '',
    city: address.address.city,
    state: address.address.state,
    zip: address.address.postal_code,
    country: address.address.country,
    phone: address.phone,
  };
}
